import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "acc-name" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getAuthInfoMSGraph.account.name), 1 /* TEXT */),
    (_ctx.getUserPicture)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.getUserPicture,
          alt: "user-avatar",
          class: "user-avatar"
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    (!_ctx.getUserPicture)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 1,
          name: "o_account_circle",
          style: {"color":"#ed0000"}
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}